import { AxiosInstance } from "axios";

import { handlerMetaInterceptor } from "./handler-meta";
import { handlerAuthenticationInterceptor } from "./handler-authentication";

export const interceptorRequest = (instance: AxiosInstance) => {
  instance.interceptors.request.use(handlerAuthenticationInterceptor);
  instance.interceptors.request.use(handlerMetaInterceptor);
};
